
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ValueAccessorBase } from '../_entities/value-accessor-base';


@Component({
  selector: 'lean-input',
  templateUrl: './lean-input.component.html',
  styleUrls: ['./lean-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: LeanInputComponent,
    multi: true,
  }],
})

export class LeanInputComponent extends ValueAccessorBase<string> implements OnInit {

 //-------------------------------------------------------------------------------------------
 _items           = [];
  isLov           : boolean = false;
  _minWidth       : number = 300;
  _label          : string;
  _visible        : boolean = true;
  _readOnly       : boolean = false;
  _insertOnly     : boolean = false;
  _type           : string = 'text';
  _modal          : any;  
  _subProp        : string;
//-------------------------------------------------------------------------------------------
 
  //-------------------------------------------------------------------------------------------

  @Input() editMode    : string = undefined;
  @Input() bindLabel   : string;
  @Input() bindValue   : string;
  @Input() unit        : string = "";
  @Input() placeholder : string = "";
  


  @Input() set label(value: string)       {this._label = value;}
  @Input() set readOnly(value: boolean)   {this._readOnly = value;}
  @Input() set insertOnly(value: boolean) {this._insertOnly = value;}
  @Input() set type(value: string)        {this._type= value;}
  @Input() set modal(value: any)          {this._modal= value;}
  @Input() set subProp(value: string)     {this._subProp= value;}
  

  // when type = radio
  @Input() group       : string = "";
  @Input() option      : string = "";


  @Input() set field(value: any) {
    if (! value) {
      this._visible     = false;
      return;
    }
    this._label       = value.name;
    this._readOnly    = value.readOnly;
    this._insertOnly  = value.insertOnly;
    if (! value.type)  value.type = 'text';
    this._type        = value.type;
    this._visible     = true;
    this._modal       = value.modal;
    if (this._modal)  this._type = null;
    this._subProp   = value.subProp;
    }      
  //= undefined; //{ prop: '', name: '', readOnly: false, insertOnly : false };

  @Input() set lov(_items: any) {
    if (_items !== null && _items !== undefined) {
      this._items = _items;
      this.isLov = true;
    }
  }

  @Input() set minWidth(value: number) {
    this. _minWidth  = value;
  }
//-------------------------------------------------------------------------------------------
  

//-------------------------------------------------------------------------------------------
  @Output() onChg : EventEmitter<any> = new EventEmitter();  
//-------------------------------------------------------------------------------------------
  


//-------------------------------------------------------------------------------------------
  constructor(protected dialog  : MatDialog) {
    super();
  }
//-------------------------------------------------------------------------------------------
  




//-------------------------------------------------------------------------------------------
  ngOnInit() { }
//-------------------------------------------------------------------------------------------
  


//---------------------------------------------------------------------------------------------
showDataModal(){  
    let dialogRef = this.dialog.open(this._modal, {autoFocus : false, hasBackdrop : false} );
    dialogRef.afterClosed().subscribe(selectedRow => {
      if(selectedRow){
        this.value = selectedRow;
      }
    });
}
//---------------------------------------------------------------------------------------------



//-------------------------------------------------------------------------------------------
  change(e : any){
    this.onChg.emit(null);
  }
  change2(e : any){
    this.value = e;
    this.onChg.emit(null);
  }
//-------------------------------------------------------------------------------------------
  

//-------------------------------------------------------------------------------------------
  getFieldLabel() : string{
     return this._label;
  }
//-------------------------------------------------------------------------------------------
  

//-------------------------------------------------------------------------------------------
  visible() : boolean{
    if (this._label) return true;
    return this._visible;
  }
//-------------------------------------------------------------------------------------------
  

//-------------------------------------------------------------------------------------------
  editable() : boolean{
      if (this.editMode == undefined ) return true;

      if (this.editMode  == 'R') {
        return false;
      }
    
      if (! this._visible){
        return (this.editMode  != 'R') ;
      }


      if (this._readOnly){
        return false;
      }

      if (this._insertOnly) {
          return (this.editMode  == 'I');
      }

      return true;
  }
//-------------------------------------------------------------------------------------------
  

//-------------------------------------------------------------------------------------------
  getLovValue() : string {
    let result : string = "---";
    if (this.bindValue) {
      for(let item of this._items) {
        if (item[this.bindValue] == this.value) {
          result = item[this.bindLabel]; 
        } 
      }
    } else {
      if (this.value) {
        result = this.value[this.bindLabel];
      }
    }

    return result;
  }
//-------------------------------------------------------------------------------------------
  

//-------------------------------------------------------------------------------------------
  getBooleanValue(value : any) : string{
      if (value == undefined) return "";
      if (value) return 'Oui';
      if (!value) return 'Non';
  }
//-------------------------------------------------------------------------------------------
 

//-------------------------------------------------------------------------------------------
getModalValue(value : any) : string{
//  if (! this.initialValue) {
//    this.initialValue = value;
//  }
  if (value == undefined) return "";
  return value[this._subProp];
}
//-------------------------------------------------------------------------------------------


setNull() {
 // this.value = this.initialValue;
  this.value = null;
}


}
